import React from 'react';

import { Icons } from './icon-constants';
import { Modal } from './Modal';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose }) => {
  const buildTimestamp: string =
    typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'Build time unavailable';
  const appVersion: string = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown';
  const currentYear = new Date().getFullYear();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      showCloseButton={true}
      ariaLabel="About Conway"
    >
      <div className="flex flex-col items-center py-4 text-center">
        {/* App icon */}
        <div className="bg-primary/10 mb-4 flex h-16 w-16 items-center justify-center rounded-xl">
          <Icons.Info size="lg" color="primary" />
        </div>

        {/* App name */}
        <h2 className="text-foreground text-2xl font-bold">Conway</h2>

        {/* Tagline */}
        <p className="text-muted-foreground mt-1 text-sm">AI Life OS — your life, orchestrated</p>

        {/* Version & Build */}
        <div className="mt-6 space-y-1">
          <p className="text-muted-foreground text-xs">
            Version <span className="text-foreground font-medium">v{appVersion}</span>
          </p>
          <p className="text-muted-foreground text-xs">
            Build <span className="font-mono">{buildTimestamp}</span>
          </p>
        </div>

        {/* Links */}
        <div className="mt-6 flex gap-4">
          <a
            href="/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:text-primary/80 text-sm underline underline-offset-2 transition-colors"
          >
            Privacy Policy
          </a>
          <span className="text-border">|</span>
          <a
            href="/terms.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:text-primary/80 text-sm underline underline-offset-2 transition-colors"
          >
            Terms of Service
          </a>
        </div>

        {/* Copyright */}
        <p className="text-muted-foreground mt-6 text-xs">
          &copy; {currentYear} Conway. All rights reserved.
        </p>
      </div>
    </Modal>
  );
};
